import { useTranslation } from 'react-i18next';
import { SPREAD_TYPES } from '../tarot-data/cards';
import { useSpreadLocalizer } from '../i18n/useLocalized';
import SpreadDiagram from './SpreadDiagram';
import useReveal from '../hooks/useReveal';
import './SpreadSelector.css';

/**
 * The first step of a reading. Once a spread is chosen it is `locked`: the
 * chosen spread stays lit and the others are dimmed and can't be picked.
 */
function SpreadSelector({ selectedId = null, locked = false, onSelectSpread }) {
  const { t } = useTranslation();
  const localizeSpread = useSpreadLocalizer();
  const revealRef = useReveal();

  const handleSelect = (spreadKey) => {
    // The reading itself is localized downstream; pass the raw spread so the
    // card and position ids the reading logic keys on stay untouched.
    onSelectSpread(SPREAD_TYPES[spreadKey]);
  };

  return (
    <div className="spread-selector" ref={revealRef}>
      <header className="spread-selector__head reveal">
        <p className="spread-selector__eyebrow">{t('dash.heading')}</p>
        <h2 className="spread-selector__title">{t('spreads.chooseHeading')}</h2>
        <div className="spread-selector__rule" aria-hidden="true">
          <span className="spread-selector__diamond" />
        </div>
      </header>

      <ul className="spread-grid">
        {Object.entries(SPREAD_TYPES).map(([key, rawSpread]) => {
          const spread = localizeSpread(rawSpread);
          const count = spread.positions.length;
          const selected = spread.id === selectedId;

          return (
            <li key={spread.id} className="reveal">
              <button
                type="button"
                className={`spread-card ${selected ? 'selected' : ''}`}
                onClick={() => handleSelect(key)}
                aria-pressed={selected}
                disabled={locked}
              >
                <span className="spread-card__plate">
                  <SpreadDiagram spreadId={spread.id} />
                </span>
                <span className="spread-card__count">{t('spreads.cardCount', { count })}</span>
                <span className="spread-card__title">{spread.name}</span>
                <span className="spread-card__text">{spread.description}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SpreadSelector;
